import { Link } from "wouter";
import { ReactNode, AnchorHTMLAttributes } from "react";

const CLIENT_ROUTES = ["/docs", "/blog"];

function isClientRoute(href: string): boolean {
  if (href.startsWith("http://") || href.startsWith("https://")) return false;
  if (href.startsWith("#")) return false;
  if (CLIENT_ROUTES.includes(href)) return true;
  if (href.startsWith("/docs/") || href.startsWith("/blog/")) return true;
  return false;
}

interface SiteLinkProps extends Omit<
  AnchorHTMLAttributes<HTMLAnchorElement>,
  "href"
> {
  href: string;
  children: ReactNode;
  className?: string;
}

export function SiteLink({
  href,
  children,
  className,
  ...props
}: SiteLinkProps) {
  if (isClientRoute(href)) {
    return (
      <Link href={href} className={className} {...props}>
        {children}
      </Link>
    );
  }

  return (
    <a href={href} className={className} {...props}>
      {children}
    </a>
  );
}
